import { render, staticRenderFns } from "./CiblesList.vue?vue&type=template&id=6cd5b398&"
import script from "./CiblesList.vue?vue&type=script&lang=js&"
export * from "./CiblesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports